import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const INVALID_DATE_TIME_VALUE = 'Invalid date'
export const INVALID_DATE_MESSAGE = 'วันที่ไม่ถูกต้อง'
export const INVALID_TIME_MESSAGE = 'เวลาไม่ถูกต้อง'
export const INVALID_DATE_TIME_MESSAGE = 'วันที่หรือเวลาไม่ถูกต้อง'

export const parseDateInput = (value, format = '') => {
  let inputFormat = format.replace(/B/g, 'Y')
  let date = dayjs(value, inputFormat, true)

  return date.isValid() ? date : null
}

export const getTimeInputValue = (value, format = '') => {
  if (!value) return ''

  let time = dayjs(value, format, true)

  return time.isValid()
    ? time.format('HH:mm:ss')
    : INVALID_DATE_TIME_VALUE
}
